/* eslint-disable  */
export const UserRole = {
  Admin: 0,
  Editor: 1,
  BBO: 2,
  BBPLUS: 3,
  OTHER: 4,
};

/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'es';
export const localeOptions = [
  { id: 'es', name: 'Español', direction: 'ltr' },
  { id: 'en', name: 'English', direction: 'ltr' },
  // { id: 'en', name: 'English - LTR', direction: 'ltr' },
  // { id: 'enrtl', name: 'English - RTL', direction: 'rtl' },
];

export const firebaseConfig = {
  apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
  authDomain: 'gogo-react-login.firebaseapp.com',
  databaseURL: 'https://gogo-react-login.firebaseio.com',
  projectId: 'gogo-react-login',
  storageBucket: 'gogo-react-login.appspot.com',
  messagingSenderId: '216495999563',
};

export const adminRoot = '/app';
export const buyUrl = 'https://1.envato.market/k4z0';
export const searchPath = `${adminRoot}/#`;
export const servicePath = 'https://api.coloredstrategies.com';

function getRole() {
  const userData = localStorage.getItem('gogo_current_user');
  if (userData) {
    const { service } = JSON.parse(userData);

    let userRole = UserRole.OTHER;
    switch (service) {
      case 'BBO':
        userRole = UserRole.BBO;
        break;
      case 'BBPLUS':
        userRole = UserRole.BBPLUS;
        break;
      default:
        userRole = UserRole.OTHER;
    }
    return userRole;
  }
  return UserRole.OTHER;
}

export const currentUser = {
  id: 1,
  title: 'Sarah Kortney',
  img: '/assets/img/profiles/l-1.jpg',
  date: 'Last seen today 15:24',
  role: getRole(),
};

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light.orangecarrot';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];
